module.exports = __webpack_public_path__ + "img/vintage-test-three.06451347.jpg";